console.log("init Proteus treatments -- 1.03")

//
// START shipping delay for inventory check
//

function in_time_window() {
  const now = new Date();

  // start/end in PDT explicitly (-7:00)
  const start = new Date("2026-05-09T06:00:00-05:00"); // May 9, 6:00 AM PDT
  const end   = new Date("2026-05-15T23:59:59-05:00"); // May 15, 11:59:59 PM PDT

  return now >= start && now <= end;
}

if (in_time_window() || window.location.href.indexOf("?shipping") > -1) {
  proteus.add_cartAttribute("proteus_checkout_option", "shipping note active");
  observeSelector('cart-drawer form.buy-buttons', checkout => {
    checkout.insertAdjacentHTML("afterend", `
      <style>
      .js-shipping-message{
        text-align: center;
        position: relative;
        font-size: .85rem;
        border-radius: 10px;
        margin: auto;
        max-width: 300px;
      }
      .js-shipping-message:before{
        content: "i";
        position: absolute;
        left: -1.5rem;
        top: 0;
        font-size: 12px;
        line-height: 0;
        border: 1px solid;
        border-radius: 100%;
        width: 1.25rem;
        height: 1.25rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      </style>
      <div style="margin: 0 2rem 0 3rem;">
        <div class="js-shipping-message">
          Please be aware, orders placed on Friday, May 15 will ship out Monday, May 18.
        </div>  
      </div>
    `);
  })
}

//
// END shipping delay for inventory check
//


// [ARG-14] — Frequency dropdown labels with servings/day info
window.activateARG14 = function () {
  getUnitsPerContainer = function(variantId) {
    const variantLevel = parseFloat(window.ARG_VARIANT_METAFIELDS?.[String(variantId)]?.unitsPerContainer);
    if (!isNaN(variantLevel) && variantLevel > 0) return variantLevel;
    const singleSize = parseFloat(window.ARG_PRODUCT_METAFIELDS?.unitsPerContainer);
    return isNaN(singleSize) || singleSize <= 0 ? null : singleSize;
  };

  function updateFreqLabels() {
    const freqSelect = document.querySelector('#arg-frequency-select');
    if (!freqSelect) return;

    const variantId = document.querySelector('.arg-size-card.is-selected')?.dataset.variantId
      || document.querySelector('.arg-size-card')?.dataset.variantId;

    const servingSize = parseFloat(window.ARG_PRODUCT_METAFIELDS?.servingSize);
    const unitsPerContainer = getUnitsPerContainer(variantId);

    if (!servingSize || !unitsPerContainer) return;

    const servingsInBottle = unitsPerContainer / servingSize;

    function servingsPerDayLabel(months) {
      const spd = servingsInBottle / (months * 30);
      if (Number.isInteger(spd) && spd > 1) return `${spd} servings / day`;
      if (spd >= 1.8) return `~${Math.round(spd)} servings / day`;
      if (Math.abs(spd - 1) < 0.01) return `1 serving / day`;
      if (spd >= 0.8) return `~1 serving / day`;
      if (Math.abs(spd - 0.5) < 0.01) return `1 serving / every other day`;
      if (spd >= 0.45) return `~1 serving / every other day`;
      const days = 1 / spd;
      return Number.isInteger(days) ? `1 serving / every ${days} days` : `1 serving / every ~${Math.round(days)} days`;
    }

    Array.from(freqSelect.options).forEach(option => {
      const monthMatch = option.textContent.match(/(\d+)\s*month/i);
      if (!monthMatch) return;
      const months = parseInt(monthMatch[1], 10);
      const baseLabel = `Every ${months} Month${months > 1 ? 's' : ''}`;
      option.textContent = `${baseLabel} (${servingsPerDayLabel(months)})`;
    });

    // Auto-select the option closest to 1 serving / day
    let bestOption = null;
    let bestDiff = Infinity;

    Array.from(freqSelect.options).forEach(option => {
      const monthMatch = option.textContent.match(/(\d+)\s*month/i);
      if (!monthMatch) return;
      const months = parseInt(monthMatch[1], 10);
      const spd = servingsInBottle / (months * 30);
      const diff = Math.abs(spd - 1);
      if (diff < bestDiff) {
        bestDiff = diff;
        bestOption = option;
      }
    });

    if (bestOption) {
      freqSelect.value = bestOption.value;
      freqSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  waitUntil(() => document.querySelector('#arg-frequency-select')).then(() => {
    updateFreqLabels();

    const freqSelect = document.querySelector('#arg-frequency-select');
    
    let _arg14Updating = false;
    new MutationObserver(() => {
      if (_arg14Updating) return;
      _arg14Updating = true;
      updateFreqLabels();
      _arg14Updating = false;
    }).observe(freqSelect, { childList: true });

  }).catch();

  // Re-run when selected size card changes
  observeSelector('.arg-size-card.is-selected', () => {
    updateFreqLabels();
  });
};
/// end [ARG-14]

observeSelector('[src*="rebuy"], [class*="rebuy"], [id*="rebuy"]', rebuy_element => {
  rebuy_element.remove();
});

let delivery_options_html = ""
waitForElement('recharge-subscription-widget').then(rc => {

  waitUntil(() => {
    return rc.shadowRoot;
  }).then(() => {

    let rc_root = rc.shadowRoot;
    // console.log("check 1", rc_root.innerHTML)

    waitUntil(() => {
      return rc_root.querySelectorAll('rc-selling-plans').length > 0 && rc_root.querySelector('rc-selling-plans').shadowRoot;
    }).then(() => {

      let rc_sp_root = rc_root.querySelector('rc-selling-plans').shadowRoot;
      // console.log("check 2", rc_sp_root.innerHTML)
      waitUntil(() => {
        return rc_sp_root.querySelectorAll('select').length > 0;
      }).then(() => {

        // let rc_sp_options = rc_sp_root.querySelectorAll('select option');
        delivery_options_html = rc_sp_root.querySelector('select').innerHTML
        // console.log("check 3", delivery_options_html);

      }).catch();

    }).catch();
  }).catch();
}).catch();

// =============================================================================
// ALLERGY RESEARCH GROUP – Custom Product Selection UI
// =============================================================================
// Replaces the Recharge subscription widget with a custom purchase option UI:
//   - One-Time Purchase card
//   - Subscribe & Save card (with frequency dropdown)
//   - Size cards rendered below both option blocks
//
// Cart submissions are intercepted via fetch + form submit overrides to ensure
// the correct variant ID, selling_plan, and quantity are always sent.
//
// DEPENDENCIES:
//   - waitForElement(selector) → Promise, resolves when element appears in DOM
//   - waitUntil(conditionFn)   → Promise, resolves when condition is truthy
//   Both must be loaded before this script (via proteus-utils or equivalent).
// =============================================================================

// =============================================================================
// SETTINGS
// =============================================================================
const SETTINGS = {
  // -- Experiment / Logging --------------------------------------------------
  experimentId: "ARG-10",
  version: "v1.03",
  logPrefix: "ARG Treatments",
  logVersion: "1.03",

  // -- Activation ------------------------------------------------------------
  // Exposed as window.activateARG10(). Must be called by external script.
  // Returns a Promise that resolves when the UI is injected.

  // -- Product Filter --------------------------------------------------------
  // List of product handles this script should activate on.
  // Empty array = all product pages.
  productHandles: [],

  // -- Subscription Discount -------------------------------------------------
  subscribeDiscountPct: 0.1, // 10 % off

  // -- Brand Colors ----------------------------------------------------------
  brandPrimary: "#42474D", // dark gray — borders, text, radio dots
  brandAccent: "#f3665f", // soft red — sale prices, savings text, badges
};

function format(price) {
  const currency = window.Shopify?.currency?.active || "USD";
  const locale   = window.Shopify?.locale           || "en-US";
  const formatter = new Intl.NumberFormat(locale, {
    style:    "currency",
    currency: currency,
  });
  return formatter.format(price);
}

// =============================================================================
// HELPER — Fetch product data from Shopify AJAX API
// =============================================================================
async function fetchShopifyProduct() {
  const parts = window.location.pathname.split("/").filter(Boolean);
  const i = parts.indexOf("products");
  if (i === -1 || i >= parts.length - 1) return null;
  const handle = parts[i + 1];
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return await res.json();
  } catch (err) {
    console.error(`[${SETTINGS.experimentId}] Failed to fetch product:`, err);
    return null;
  }
}

function parseUnitsFromTitle(title) {
  if (!title) return null;
  const match = title.match(/^(\d+)\s*([a-z][a-z\s]*)/i);
  if (!match) return null;
  const count = parseInt(match[1], 10);
  const unit = match[2].trim();

  const unitLabel = unit.charAt(0).toUpperCase() + unit.slice(1).toLowerCase();
  return {
    count,
    label: `${count} ${unitLabel}`,
    unit: unitLabel,
  };
}

// =============================================================================
// HELPER — Get container size and serving size from the Liquid-injected metafield map
// Requires this snippet in your Liquid template BEFORE this script loads:
// <script>
//   window.ARG_PRODUCT_METAFIELDS = {
//     servingSize: {{ product.metafields.custom.serving_size | default: 'null' }}
//     unitsPerContainer: {{ product.metafields.custom.units_per_container | default: 'null' }}
//   };
//   window.ARG_VARIANT_METAFIELDS = {
//     {% for variant in product.variants %}
//       "{{ variant.id }}": {
//         unitsPerContainer: {{ variant.metafields.custom.variant_serving_size | default: 'null' }}
//       }{% unless forloop.last %},{% endunless %}
//     {% endfor %}
//   };
// </script>
//
// Returns the serving size (number) or null if not defined.
// =============================================================================
function getServingSize() {
  const value = parseFloat(window.ARG_PRODUCT_METAFIELDS?.servingSize);
  return isNaN(value) || value <= 0 ? null : value;
}
function getUnitsPerContainer(variantId) {
  const value = parseFloat(window.ARG_VARIANT_METAFIELDS?.[String(variantId)]?.unitsPerContainer);
  return isNaN(value) || value <= 0 ? null : value;
}

function getVariantIdFromUrl() {
  return new URLSearchParams(window.location.search).get("variant") || "";
}
function setVariantIdInUrl(variantId) {
  const url = new URL(window.location.href);
  url.searchParams.set("variant", variantId);
  window.history.replaceState({}, "", url.toString());
}

// =============================================================================
// MAIN ACTIVATION — exposed as window.activateARG10()
// =============================================================================
window.activateARG10 = async function activateARG10() {
  // Guard against double activation
  if (window._arg10Active) {
    console.log(`[${SETTINGS.experimentId}] Already active. Skipping.`);
    return;
  }
  window._arg10Active = true;
  console.log(`init ${SETTINGS.logPrefix} -- ${SETTINGS.logVersion}`);

  // --------------------------------------------------------------------------
  // Product handle guard
  // --------------------------------------------------------------------------
  if (SETTINGS.productHandles && SETTINGS.productHandles.length > 0) {
    const parts = window.location.pathname.split("/").filter(Boolean);
    const pi = parts.indexOf("products");
    const handle = pi !== -1 ? parts[pi + 1] : "";
    if (!SETTINGS.productHandles.includes(handle)) {
      console.log(
        `[${SETTINGS.experimentId}] Handle "${handle}" not in list. Skipping.`,
      );
      return;
    }
  }

  // --------------------------------------------------------------------------
  // Fetch live product data
  // --------------------------------------------------------------------------
  const shopifyProduct = await fetchShopifyProduct();
  if (!shopifyProduct) {
    console.log(`[${SETTINGS.experimentId}] Product fetch failed. Exiting.`);
    return;
  }

  // --------------------------------------------------------------------------
  // Build productOptions from Shopify variants
  // --------------------------------------------------------------------------
  const productOptions = [];

  (shopifyProduct.variants || []).forEach((variant) => {

    const parsed = parseUnitsFromTitle(variant.title);
    const metafieldCount = parseFloat(window.ARG_VARIANT_METAFIELDS?.[String(variant.id)]?.unitsPerContainer);
    const unitCount = parsed?.count ?? (isNaN(metafieldCount) ? null : metafieldCount);

    if (!unitCount) {
      console.log(`[${SETTINGS.experimentId}] Could not parse units from "${variant.name}". -- set the variant metafield for serving size`);
      // return;
    }
    const unit = parsed?.unit ?? "Units";
    const unitPrice = variant.price / 100;
    const subPrice = unitPrice * (1 - SETTINGS.subscribeDiscountPct);
    productOptions.push({
      variantId: String(variant.id),
      title: variant.title,
      label: parsed?.label ?? `${unitCount} ${unit}`,
      unitCount,
      unit,
      image: variant.featured_image
        ? variant.featured_image.src
        : shopifyProduct.featured_image || "",
      priceOtp: unitPrice,
      priceSub: subPrice,
      available: variant.available,
    });
  });

  productOptions.sort((a, b) => a.unitCount - b.unitCount);

  if (productOptions.length === 0) {
    console.log(`[${SETTINGS.experimentId}] No valid options found. Exiting.`);
    return;
  }

  const baseOtpPricePerUnit = productOptions[0].priceOtp / productOptions[0].unitCount;

  const urlVariantId = getVariantIdFromUrl();
  let selectedIndex = 0;
  productOptions.forEach((opt, i) => {
    if (opt.variantId === urlVariantId) selectedIndex = i;
  });
  let selectedOption = productOptions[selectedIndex];
  const discountLabel = Math.round(SETTINGS.subscribeDiscountPct * 100);


  // ==========================================================================
  // BUILD HTML
  // ==========================================================================
  function buildSizeCardsHtml(mode) {
    const unitsPerServing = getServingSize(); // custom.serving_size e.g. 2

    return productOptions.map((opt, index) => {
      const isSelected      = index === selectedIndex ? "is-selected" : "";
      const isOOS           = !opt.available ? "out-of-stock" : "";
      const price           = mode === "sub" ? opt.priceSub : opt.priceOtp;


      const unitsPerContainer = getUnitsPerContainer(opt.variantId) ?? opt.unitCount;

      const servings = (unitsPerContainer && unitsPerServing)
        ? Math.floor(unitsPerContainer / unitsPerServing)
        : null;

      const pricePerServing = (servings && servings > 0)
        ? format(price / servings)
        : null;

      return `
        <li class="arg-size-item" data-option-index="${index}">
          <button type="button"
                  class="arg-size-card ${isSelected} ${isOOS}"
                  ${!opt.available ? "disabled" : ""}
                  data-variant-id="${opt.variantId}"
                  data-option-index="${index}">
            <div class="arg-card-media">
              <img src="${opt.image}"
                  width="200" height="200"
                  class="arg-product-image"
                  alt="${opt.label}" />
            </div>
            <span class="arg-size-name">${unitsPerContainer} ${opt.unit}</span>
            ${servings
              ? `<span class="arg-size-supply">${servings} servings</span>`
              : ""}
            ${pricePerServing
              ? `<span class="arg-size-per-serving">${pricePerServing} / serving</span>`
              : ""}
          </button>
        </li>
      `;
    }).join("");
  }

  function buildFrequencyHtml() {
    /*
    return Object.entries(SETTINGS.frequencies)
      .map(
        ([key, freq], i) => `<option value="${freq.sellingPlanId}"
                  data-freq-key="${key}"
                  ${key === currentFreqKey ? "selected" : ""}>
          ${freq.label}
        </option>`,
      )
      .join("");
      */
  }

  function buildFullHtml() {
    const otpTotal = selectedOption.priceOtp;
    const subTotal = selectedOption.priceSub;
    const subSavings = otpTotal - subTotal;

    return `
      <div class="arg-purchase-options" data-mode="otp">

        <!-- ONE-TIME PURCHASE -->
        <div class="arg-option-block arg-otp is-selected" data-mode="otp">
          <div class="arg-radio-row">
            <div class="arg-radio">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
                <circle class="arg-radio-dot" cx="12" cy="12" r="6" fill="currentColor"/>
              </svg>
            </div>
            <div class="arg-option-header">
              <h2 class="arg-option-title">One-Time Purchase</h2>
              <div class="arg-option-price-col">
                <p class="arg-option-price">
                  <span id="arg-otp-compare" class="arg-compare-price" style="display:none;"></span>
                  <span id="arg-otp-total" class="arg-total-price" data-total="${otpTotal}">${format(otpTotal)}</span>
                </p>
                <p id="arg-otp-savings-row" class="arg-savings" style="display:none;">
                  You save <span id="arg-otp-savings"></span>!
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- SUBSCRIBE & SAVE -->
        <div class="arg-option-block arg-sub" data-mode="sub">
          <div class="arg-radio-row">
            <div class="arg-radio">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.5"/>
                <circle class="arg-radio-dot" cx="12" cy="12" r="6" fill="currentColor"/>
              </svg>
            </div>
            <div class="arg-option-header">
              <h2 class="arg-option-title">Subscribe &amp; Save ${discountLabel}%</h2>
              <div class="arg-option-price-col">
                <p class="arg-option-price">
                  <span id="arg-sub-compare" class="arg-compare-price">${format(otpTotal)}</span>
                  <span id="arg-sub-total" class="arg-total-price arg-sale">${format(subTotal)}</span>
                </p>
                <p class="arg-savings">
                  You save <span id="arg-sub-savings">${format(subSavings)}</span>!
                </p>
              </div>
            </div>
          </div>
          <div class="arg-frequency-wrapper" style="display:none;">
            <label class="arg-freq-label" for="arg-frequency-select">
              Delivery Frequency
            </label>
            <select class="arg-frequency-select" id="arg-frequency-select">
              ${delivery_options_html}
            </select>
          </div>
        </div>

        <!-- SIZE CARDS -->
        ${productOptions.some(opt => getUnitsPerContainer(opt.variantId) ?? opt.unitCount) ? `
        <div class="arg-sizes-section">
          <h3 class="arg-sizes-heading">Choose Your Size</h3>
          <ul class="arg-sizes-list">
            ${buildSizeCardsHtml("otp")}
          </ul>
        </div>` : ""}

      </div>
    `;
  }
  const cssStyles = `
    <style id="arg-custom-styles">
      /* Hide elements replaced by this UI */
      .product-info .shopify-block.recharge-subscription-widget,
      .product-info recharge-subscription-widget,
      .product-info__price,
      .product-info__variant-picker,
      .product-info__quantity-selector {
        display: none !important;
      }

      /* ---- Container ---- */
      .arg-purchase-options {
        max-width: 100%;
        margin-bottom: 20px;
        font-family: inherit;
      }

      /* ---- Option Blocks ---- */
      .arg-option-block {
        border: 1.5px solid #ddd;
        border-radius: 6px;
        padding: 14px 16px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: border-color 0.2s ease, background-color 0.2s ease;
        position: relative;
      }

      .arg-option-block.is-selected {
        border-color: ${SETTINGS.brandPrimary};
        border-width: 2px;
      }

      .arg-option-block:not(.is-selected) .arg-radio-dot {
        display: none;
      }
      .arg-option-block:not(.is-selected) .arg-savings,
      .arg-option-block:not(.is-selected) .arg-frequency-wrapper {
        display: none !important;
      }

      /* ---- Radio Row ---- */
      .arg-radio-row {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .arg-radio {
        display: flex;
        flex-shrink: 0;
        color: ${SETTINGS.brandPrimary};
      }

      /* ---- Option Header ---- */
      .arg-option-header {
        flex: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
      }

      .arg-option-block .arg-option-title {
        font-size: 1rem;
        margin: 0;
      }

      /* ---- Pricing ---- */
      .arg-option-price {
        margin: 0;
        font-weight: 800;
        font-size: 1.2rem;
        display: flex;
        align-items: baseline;
        gap: 6px;
      }

      .arg-compare-price {
        text-decoration: line-through;
        font-size: .9rem;
        font-weight: 400;
        color: #767676;
      }

      .arg-total-price {
        color: ${SETTINGS.brandPrimary};
      }

      .arg-sale {
        color: ${SETTINGS.brandAccent};
      }

      /* ---- Savings line ---- */
      .arg-option-price-col {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }

      .arg-savings {
        font-size: .9rem;
        margin: 0;
        color: ${SETTINGS.brandAccent};
        font-weight: 600;
        line-height: 1;
      }

      /* ---- Frequency Dropdown ---- */
      .arg-frequency-wrapper {
        margin-top: 15px;
      }

      .arg-freq-label {
        display: block;
        font-size: .8rem;
        font-weight: 600;
        margin-bottom: 4px;
        color: ${SETTINGS.brandPrimary};
      }

      .arg-frequency-select {
        width: 100%;
        font-size: 14px;
        padding: 10px 36px 10px 12px;
        border: 1.5px solid ${SETTINGS.brandPrimary};
        border-radius: 4px;
        background: #fff;
        color: ${SETTINGS.brandPrimary};
        appearance: none;
        -webkit-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none'%3E%3Cpath stroke-width='0' fill='%2342474D' d='M21.4,6.6l-9.4,6.6L2.6,6.6l-.6.9,8.5,8.9c.7.8,1.1,1,1.5,1s.8-.3,1.5-1l8.5-8.9-.6-.9Z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: calc(100% - 10px) center;
        background-size: 16px;
        cursor: pointer;
        font-family: inherit;
      }

      /* ---- Size Section ---- */
      .arg-sizes-section {
        margin-top: 18px;
      }

      .arg-sizes-heading {
        margin-bottom: 5px;
      }

      .arg-sizes-list {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        gap: 10px;
        transition: opacity 0.25s ease, transform 0.25s ease;
      }

      .arg-sizes-list.arg-transitioning-out {
        opacity: 0;
        transform: translateY(6px);
      }

      .arg-sizes-list.arg-transitioning-in {
        opacity: 0;
        transform: translateY(-6px);
      }

      .arg-size-item {
        flex: 1;
        min-width: 0;
      }

      /* ---- Size Cards ---- */
      .arg-size-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
        padding: 10px 6px 8px;
        border: 1.5px solid #ddd;
        border-radius: 6px;
        background: #fff;
        cursor: pointer;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        position: relative;
        font-family: inherit;
        text-align: center;
        gap: 2px;
      }

      .arg-option-block:not(.is-selected):hover,
      .arg-size-card:not(.is-selected):hover {
        border-color: ${SETTINGS.brandAccent};
      }

      .arg-size-card.is-selected {
        border-color: ${SETTINGS.brandPrimary};
        border-width: 2px;
        box-shadow: 0 0 0 1px ${SETTINGS.brandPrimary}22;
      }

      .arg-size-card.out-of-stock {
        opacity: 0.4;
        pointer-events: none;
        cursor: not-allowed;
      }

      /* ---- Size Card Media ---- */
      .arg-card-media {
        width: 100%;
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }

      .arg-product-image {
        width: 70px;
        height: 70px;
        object-fit: contain;
      }

      /* ---- Size Card Labels ---- */
      .arg-size-name {
        font-size: .9rem;
        font-weight: 700;
        color: ${SETTINGS.brandPrimary};
        line-height: 1.3;
      }

      .arg-size-supply {
        font-size: .9rem;
        color: ${SETTINGS.brandPrimary};
      }

      .arg-size-per-serving {
        font-size: .9rem;
        color: #767676;
        line-height: 1.3;
      }
      .arg-purchase-options[data-mode="sub"] .arg-size-per-serving {
        color: ${SETTINGS.brandAccent};
        font-weight: 600;
      }

      /* ---- Responsive ---- */
      @media screen and (min-width: 769px) {
        .arg-savings {
          text-align: right;
          margin: 0;
        }
      }

      @media screen and (max-width: 768px) {
        .arg-sizes-list { gap: 6px; }
        .arg-size-card { padding: 8px 4px 6px; }
        .arg-card-media { height: 60px; }
        .arg-frequency-wrapper { margin-top: 15px; }

        .arg-product-image {
          width: 50px;
          height: 50px;
        }

        .arg-option-header {
          flex-direction: column;
          align-items: flex-start;
        }
        .arg-option-price-col {
          align-items: flex-start;
          flex-shrink: 0;
          margin-left: auto;
        }
      }
    </style>
  `;

  // ==========================================================================
  // INJECT UI
  // ==========================================================================
  waitForElement(".product-info__buy-buttons").then(anchor => {

    waitUntil(() => {
      return delivery_options_html != "";
    }).then(() => {
    
      anchor.insertAdjacentHTML("beforebegin", cssStyles + buildFullHtml());

      // Remove options beyond first 3
      const freqSelectInit = document.querySelector('#arg-frequency-select');
      while (freqSelectInit && freqSelectInit.options.length > 3) {
        freqSelectInit.remove(3);
      }

      const root = document.querySelector(".arg-purchase-options");
      const otpBlock = root.querySelector(".arg-otp");
      const subBlock = root.querySelector(".arg-sub");
      const freqSelect = root.querySelector(".arg-frequency-select");
      const freqWrapper = root.querySelector(".arg-frequency-wrapper");

      let currentMode = "otp";
      const mainProductForm = document.querySelector('form[id$="__main"][action="/cart/add"]:not([id*="installment"])');

      function rebuildSizeCards(mode) {
        const sizeList = root.querySelector(".arg-sizes-list");
        if (!sizeList) return;

        sizeList.classList.add("arg-transitioning-out");
        setTimeout(() => {
          sizeList.innerHTML = buildSizeCardsHtml(mode);

          sizeList.querySelectorAll(".arg-size-card").forEach(card => {
            card.addEventListener("click", e => {
              e.stopPropagation();
              const index = parseInt(card.getAttribute("data-option-index"), 10);
              selectSize(index);
            });
          });

          sizeList.classList.remove("arg-transitioning-out");
          sizeList.classList.add("arg-transitioning-in");
          void sizeList.offsetHeight;
          sizeList.classList.remove("arg-transitioning-in");
        }, 250);
      }

      function updatePrices() {
        let otpTotal   = selectedOption.priceOtp;
        const tags = (window.ARG_CUSTOMER?.tags || []).map(t => t.toLowerCase());
        const isPractitioner = tags.some(t => t === 'practitioner');
        const isPatient = tags.some(t => t === 'patient');
        const isConsumer = !isPractitioner && !isPatient;

        if (isPatient) {
          otpTotal = (selectedOption.priceOtp * 0.8).toFixed(2);
        } else if (isPractitioner) {
          otpTotal = (selectedOption.priceOtp * 0.5).toFixed(2);
        }

        const subTotal   = selectedOption.priceSub;
        const subSavings = otpTotal - subTotal;

        const thisPricePerCap = otpTotal / selectedOption.unitCount;
        const otpSavings = (baseOtpPricePerUnit - thisPricePerCap) * selectedOption.unitCount;
        const showOtpSavings = otpSavings > 0.01;

        const otpCompareEl    = document.getElementById("arg-otp-compare");
        const otpSavingsRow   = document.getElementById("arg-otp-savings-row");
        const otpSavingsSpan  = document.getElementById("arg-otp-savings");
        const otpTotalEl      = document.getElementById("arg-otp-total");

        otpTotalEl.textContent = format(otpTotal);

        if (showOtpSavings) {
          const baseEquivalent = baseOtpPricePerUnit * selectedOption.unitCount;
          otpCompareEl.textContent  = format(baseEquivalent);
          otpCompareEl.style.display = "";
          otpSavingsSpan.textContent = format(otpSavings);
          otpSavingsRow.style.display = "";
        } else {
          otpCompareEl.style.display  = "none";
          otpSavingsRow.style.display = "none";
        }

        // document.getElementById("arg-sub-compare").textContent = format(otpTotal);
        // document.getElementById("arg-sub-total").textContent   = format(subTotal);
        // document.getElementById("arg-sub-savings").textContent = format(subSavings);

        const el1 = document.getElementById("arg-sub-compare");
        if (el1) el1.textContent = format(otpTotal);

        const el2 = document.getElementById("arg-sub-total");
        if (el2) el2.textContent = format(subTotal);

        const el3 = document.getElementById("arg-sub-savings");
        if (el3) el3.textContent = format(subSavings);

        freqSelect.innerHTML = delivery_options_html;
        // Remove options beyond the first 3
        while (freqSelect.options.length > 3) {
          freqSelect.remove(3);
        }
      }

      // init 
      updatePrices();

      function setMode(mode) {
        if (mode === currentMode) return;
        currentMode = mode;
        root.setAttribute("data-mode", mode);

        if (mode === "otp") {
          otpBlock.classList.add("is-selected");
          subBlock.classList.remove("is-selected");
          freqWrapper.style.display = "none";
        } else {
          otpBlock.classList.remove("is-selected");
          subBlock.classList.add("is-selected");
          freqWrapper.style.display = "block";
        }

        rebuildSizeCards(mode);
        syncFormInputs();
      }

      function selectSize(index) {
        selectedIndex = index;
        selectedOption = productOptions[index];

        root.querySelectorAll(".arg-size-card").forEach((card, i) => {
          card.classList.toggle("is-selected", i === index);
        });

        setVariantIdInUrl(selectedOption.variantId);
        updatePrices();
        selectShopifyVariant(selectedOption.variantId);
        syncFormInputs();
      }

      function selectShopifyVariant(variantId) {
        if (!mainProductForm) return;
        const idInput = mainProductForm.querySelector('input[name="id"]');
        if (idInput) {
            idInput.value = variantId;
            idInput.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      // ------------------------------------------------------------------
      // Sync the hidden selling_plan input in the Shopify product form
      // ------------------------------------------------------------------
      function syncFormInputs() {
        if (!mainProductForm) return;

        const variantInput = mainProductForm.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = selectedOption.variantId;

        let spInput = mainProductForm.querySelector('input[name="selling_plan"]');

        if (currentMode === "sub") {
          if (!spInput) {
            spInput = document.createElement("input");
            spInput.type = "hidden";
            spInput.name = "selling_plan";
            mainProductForm.appendChild(spInput);
          }
          spInput.value = freqSelect.value || "";
        } else {
          if (spInput) spInput.remove();
        }
      }

      // ------------------------------------------------------------------
      // Intercept ALL fetch-based /cart/add requests
      // Ensures correct variant + selling_plan regardless of which JS
      // actually triggers the cart add (theme, apps, etc.)
      // ------------------------------------------------------------------
      const originalFetch = window.fetch;
      window.fetch = function (url, options) {
        if (
          typeof url === "string" &&
          url.indexOf("/cart/add") > -1 &&
          options?.body &&
          window._arg10Submitting
        ) {
          try {
            const body = options.body;

            if (
              typeof body === "string" &&
              body.indexOf("form_type=product") > -1
            ) {
              const params = new URLSearchParams(body);
              params.set("id", selectedOption.variantId);
              params.set("quantity", "1");

              if (currentMode === "sub") {
                params.set("selling_plan", freqSelect.value || "");
              } else {
                params.delete("selling_plan");
              }

              options.body = params.toString();
            } else if (typeof body === "string") {
              try {
                const json = JSON.parse(body);
                if (json.id != null) {
                  json.id = parseInt(selectedOption.variantId, 10);
                  json.quantity = 1;
                }
                if (json.items && json.items.length > 0) {
                  json.items[0].id = parseInt(selectedOption.variantId, 10);
                  json.items[0].quantity = 1;
                }
                if (currentMode === "sub") {
                  const planId = parseInt(freqSelect.value, 10);
                  if (json.selling_plan != null) json.selling_plan = planId;
                  if (json.items && json.items.length > 0)
                    json.items[0].selling_plan = planId;
                } else {
                  delete json.selling_plan;
                  if (json.items && json.items.length > 0)
                    delete json.items[0].selling_plan;
                }
                options.body = JSON.stringify(json);
              } catch (e) {
                /* not JSON – leave as-is */
              }
            } else if (body instanceof FormData) {
              body.set("id", selectedOption.variantId);
              body.set("quantity", "1");
              if (currentMode === "sub") {
                body.set("selling_plan", freqSelect.value || "");
              } else {
                body.delete("selling_plan");
              }
            }
          } catch (e) {
            console.error(`[${SETTINGS.experimentId}] fetch intercept error:`, e);
          }
        }
        return originalFetch.call(this, url, options);
      };

      // ------------------------------------------------------------------
      // Intercept direct form submissions (fallback for non-fetch paths)
      // ------------------------------------------------------------------
      if (mainProductForm) {
        mainProductForm.addEventListener("submit", () => {
            window._arg10Submitting = true;
            const idSelect = mainProductForm.querySelector('select[name="id"]');
          if (idSelect) {
            for (let i = 0; i < idSelect.options.length; i++) {
              if (idSelect.options[i].value === selectedOption.variantId) {
                idSelect.options[i].selected = true;
                break;
              }
            }
          }

          const idInput = mainProductForm.querySelector('input[name="id"].product-variant-id');
          if (idInput) idInput.value = selectedOption.variantId;

          let spInput = mainProductForm.querySelector('input[name="selling_plan"]');
          if (!spInput) {
            spInput = document.createElement("input");
            spInput.type = "hidden";
            spInput.name = "selling_plan";
            mainProductForm.appendChild(spInput);
          }
          spInput.value = currentMode === "sub" ? freqSelect.value || "" : "";

          let qtyInput = mainProductForm.querySelector('input[name="quantity"]');
          if (!qtyInput) {
            qtyInput = document.createElement("input");
            qtyInput.type = "hidden";
            qtyInput.name = "quantity";
            mainProductForm.appendChild(qtyInput);
          }
          qtyInput.value = "1";
          setTimeout(() => { window._arg10Submitting = false; }, 500);
        }, true);
      }

      // ------------------------------------------------------------------
      // Click handlers — option blocks
      // ------------------------------------------------------------------
      otpBlock.addEventListener("click", () => {
        setMode("otp");
        selectShopifyVariant(selectedOption.variantId);
      });

      subBlock.addEventListener("click", () => {
        setMode("sub");
        selectShopifyVariant(selectedOption.variantId);
      });

      [otpBlock, subBlock].forEach(block => {
        block.setAttribute("tabindex", "0");
        block.addEventListener("keydown", e => {
          if (e.key === "Enter" || e.key === " ") { e.preventDefault(); block.click(); }
        });
      });

      // ------------------------------------------------------------------
      // Click handlers — size cards
      // ------------------------------------------------------------------
      root.querySelectorAll(".arg-size-card").forEach((card) => {
        card.addEventListener("click", (e) => {
          e.stopPropagation();
          const index = parseInt(card.getAttribute("data-option-index"), 10);
          selectSize(index);
        });
      });

      // ------------------------------------------------------------------
      // Frequency dropdown change
      // ------------------------------------------------------------------
      freqSelect.addEventListener("change", () => {
        syncFormInputs();
      });

      // ------------------------------------------------------------------
      // Set initial state
      // ------------------------------------------------------------------
      selectShopifyVariant(selectedOption.variantId);

      // [ARG-13] Default consumers (non-practitioner, non-patient) to Subscribe & Save
      const _arg13Tags = (window.ARG_CUSTOMER?.tags || []).map(t => t.toLowerCase());
      if (!_arg13Tags.some(t => t === 'practitioner') && !_arg13Tags.some(t => t === 'patient')) {
        setMode("sub");
      }

      syncFormInputs();

      console.log(
        `[${SETTINGS.experimentId}] UI injected. Mode: ${currentMode}.`,
      );
    }).catch();
  }).catch();
};
